const parsePhone = (value: any) => {
  if (!value) return value;
  return value.replace(/[^\d]/g, "");
};

export default parsePhone;
